import Utility from "../utility/utility";
import AppData from "../pacakge/public/const/app_data";
import GameUtil from "../utility/game_util";
import LoaclStorage from "../manager/local_storage";
import TimeManager from "../manager/time_manager";
import EventManager from "../manager/event_manager";
import ModelData from "../pacakge/public/model_data";
import ModuleManager from "../framework/core/module_manager";
import LanguageManager from "../manager/language_manager";
import AppController from "./app_controller";
import UserDataManager from "../manager/user_manager";
import LogManager from "../manager/log_manager";
// import Test from "../pacakge/hall/module/test/test";

export default class IAPController extends cc.Component {

    static _lastReceiveTransactionIdentifier: string
    static _purchaseSuccessTime = 0

    static productIds = ["ioscoin_lv3", "ioscoin_lv20", "ioscoin_lv60", "iosgold_lv1", "iosgold_lv2", "iosgold_lv3", "iosgold_lv5", "iosgold_lv10", "iosgold_lv20",
        "iosgold_lv38", "iosgold_lv50", "iosgold_lv60","ioscoin_lv1","ioscoin_lv2","ioscoin_lv6","ioscoin_lv13","ioscoin_lv33","ioscoin_lv53",
        "iositem_newplayergift_lv1","iositem_newplayergift_lv2","iositem_newplayergiftlux_lv2"]

        
    public static receive(content: string, encode = true) {
        let json = JSON.parse(encode ? Utility.decodeBase64(content) : content);
        LogManager.instance.log(`IAPController receive funcName: ${json.funcName} jsonParam: ${json.param}`, true)
        if (json.funcName == "purchaseSuccess") {
            let data = JSON.parse(json.param)
            let transactionIdentifier = data.transactionIdentifier
            if (transactionIdentifier == IAPController._lastReceiveTransactionIdentifier && new Date().getTime() - IAPController._purchaseSuccessTime < 1000) {
                cc.error("同事有多次purchaseSuccess回调", transactionIdentifier)
                return
            }
            IAPController._lastReceiveTransactionIdentifier = transactionIdentifier
            IAPController._purchaseSuccessTime = new Date().getTime();
            IAPController.createOrder(data.productId, data.transactionReceipt)
        } else if (json.funcName == "purchaseFail") {
            if (json.param != "User Cancel" && json.param != "productId purchased") {
                if (Utility.version_judge(AppData.appVersion, "1.2.3")) {  //只有大于v1.2.3才会有错误提示
                    ModuleManager.instance.toast(json.param);
                }
            }
            ModuleManager.instance.hideModule("NetPrompt")
        } else if (json.funcName == "iapProductInfo") {
            cc.systemEvent.emit("iapProductInfo", json.param)
        }else if(json.funcName == "iapInitFail"){
            this.initIapProduct()
        }
        
    }


    /**
     * 
     * @param funcName 
     * @param jsonParam 
     */
    public static requestNativeFunc(funcName: string, jsonParam: string = "") {
        if (!CC_JSB) {
            return
        }
        if (cc.sys.os != cc.sys.OS_IOS) {
            return
        }
        let jsonObj = {
            "funcName": funcName,
            "params": jsonParam
        };
        let jsonStr = JSON.stringify(jsonObj);
        let className = "IAPManager";
        LogManager.instance.log(`IAPController request funcName: ${funcName} jsonParam: ${jsonParam}`, true)
        jsb.reflection.callStaticMethod(className, "receiveJSCall:", jsonStr);
    }

    /**
 * 
 * @param funcName 
 * @param jsonParam 
 */
    public static requestNativeFuncReturn(funcName: string, jsonParam: string = ""): string {
        if (!CC_JSB) {
            return
        }
        if (cc.sys.os != cc.sys.OS_IOS) {
            return
        }
        let jsonObj = {
            "funcName": funcName,
            "params": jsonParam
        };
        let jsonStr = JSON.stringify(jsonObj);
        let result: string
        let className = "IAPManager";
        result = jsb.reflection.callStaticMethod(className, "receiveJSCallReturn:", jsonStr);
        return result
    }


    //发起内购购买
    public static buyProduct(productId: string) {
        if (CC_JSB) {
            if (cc.sys.os == cc.sys.OS_IOS) {
                this.requestNativeFunc("buyProduct", productId)
            } else {
                ModuleManager.instance.hideModule("NetPrompt")
            }
        } else {
            ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t("purchase_not_support"), () => {
                EventManager.instance.dispatch("purchase_open_download_app")
            })
            ModuleManager.instance.hideModule("NetPrompt")
        }
        // ModuleManager.instance.hideModule("NetPrompt")
    }

    public static initIap(productId) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("initIap", productId)
        }
    }
    public static initIapProduct() {
        let str = ""
        for(let i = 0;i<this.productIds.length;i++){
            if(i == 0){
                str = this.productIds[i]
            }else{
                str = str + ";" + this.productIds[i]
            }
        }
        this.initIap(str)
        this.requestProduct("0")
        
    }
    //1 返回结果 其他不返回
    public static requestProduct(req) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("requestProduct", req)
        }
    }
    //0 true 1 no
    public static setDebug(debug: number) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("setDebug", debug + "")
        }
    }
    public static consumeProduct(productId) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("consumeProduct", productId)
        }
    }
    public static addProductId(productId) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("addProductId", productId)
        }
    }
    public static restorePurchase() {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("restorePurchase")
        }
    }
    public static clearParchased(productId) {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("clearParchased", productId)
        }
    }
    public static clearAllParchased() {
        if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
            this.requestNativeFunc("clearAllParchased")
        }
    }

    public static createOrder(productId, token) {
        cc.log("开始请求purchaseInnerOrder确认")
        let requestData: IHttpRequestData = {
            baseUrl: "order/purchaseInnerOrder?",  ///mobile/order/purchaseInnerOrder
            params: {
                gameUserId: ModelData.instance.roleData.id,
                // currency: currency,//goods.getPriceCurrencyCode,
                goodsCode: productId,
                onlinePayType: 2,
                // price: price,//goods.getPriceAmountMicros / 1000000,
                packageName: "com.thsc.winner",
                purchaseToken: token
            },
            timeOutRequestMax: 0,
            logRecord : true
        }
        GameUtil.apiHttpGet(requestData, function (respone) {
            ModuleManager.instance.hideModule("NetPrompt")
            if (respone.code == "X00073" || respone.code == "X00071") {
                cc.log("交易取消")
                IAPController.consumeProduct(productId)
            } else if (respone.code == "SUCCESS") {
                cc.log("已验证通过，准备确认消费")
                // ModuleManager.instance.toastKey("purchase_success");
                UserDataManager.getCurrencyData(ModelData.instance.roleData.id, null, true, true)
                EventManager.instance.dispatch("googleBillingPurchaseSuccess", productId)
                IAPController.consumeProduct(productId)
            }
        }, function (err) {
            if (err.code == "X00073" || err.code == "X00071") {
                cc.log("交易取消")
                ModuleManager.instance.hideModule("NetPrompt")
                IAPController.consumeProduct(productId)
            } else if (err.code == "X00027") { //操作太频繁，需要稍后
                setTimeout(() => {
                    IAPController.createOrder(productId, token)
                }, 3000)
            } else {
                ModuleManager.instance.toast500error(err)
                ModuleManager.instance.hideModule("NetPrompt")
            }
        })
    }
}
//@ts-ignore
window.IAPController = IAPController;